import { render, staticRenderFns } from "./content-error.vue?vue&type=template&id=c623e3ec&"
import script from "./content-error.vue?vue&type=script&lang=js&"
export * from "./content-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-error.vue"
export default component.exports